import _get from 'lodash/get';

function drawKey(keyWrapper, activeCluster, activeSchool, schoolWithLineNodes) {
  keyWrapper.html('');

  if (activeSchool) {
    const key1 = keyWrapper.append('div');

    key1
      .append('div')
      .style('width', '30px')
      .style('height', '3px')
      .style('background', d => {
        return '#05E2FC';
      });

    key1.append('div').text(activeSchool.name);
  }

  const key2 = keyWrapper.append('div');

  key2
    .append('div')
    .style('width', '30px')
    .style('height', '1px')
    .style('background', '#7A96A5');

  const key2Text = activeSchool
    ? `Other schools in ${activeCluster.name} schools group`
    : `Schools in ${activeCluster.name} schools group`;
  key2.append('div').text(key2Text);

  const key3 = keyWrapper.append('div');

  key3
    .append('svg')
    .attr('width', 30)
    .attr('height', 3)
    .attr('viewBox', '0, 0, 30, 3').html(`
    <line x1="0" y1="0" x2="200" y2="0" style="stroke:#007C98;stroke-width:10;stroke-dasharray:6,3;stroke-dashoffset:1;" />
  `);

  key3.append('div').text(`Average of ${activeCluster.name} schools group`);

  if (
    schoolWithLineNodes &&
    schoolWithLineNodes.uid !== _get(activeSchool, 'uid', '') &&
    !schoolWithLineNodes.isClusterAggregate
  ) {
    const key3 = keyWrapper.append('div');

    key3
      .append('div')
      .style('width', '30px')
      .style('height', '3px')
      .style('background', d => {
        return '#404040';
      });

    key3.append('div').text(schoolWithLineNodes.name);
  }

  keyWrapper
    .append('div')
    .style('width', '100%')
    .text('Data subject to change.*');
}

export default drawKey;



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/drawKey.js